import {
  IMarketingCloudUser,
  SportradarEnforcer,
  SportradarEnforcerFactory,
  ActionValidationMiddleware,
  ACTION_NAME,
} from '@ads/iam-library';

let cachedEnforcer: SportradarEnforcer;

async function checkPermissionAcrossResources(
  user: IMarketingCloudUser,
  actionName: ACTION_NAME,
): Promise<boolean> {
  const actionValidator = await createActionValidator(user);
  const userId = user.getPrincipalId();

  const hasAdTagPermissions = await actionValidator.validateAction({
    actionName,
    domainName: 'creative-hub',
    resourceType: 'ad-tag',
    userId,
  });

  const hasCataloguesPermissions = await actionValidator.validateAction({
    actionName,
    domainName: 'creative-hub',
    resourceType: 'catalogue',
    userId,
  });

  return hasAdTagPermissions || hasCataloguesPermissions;
}

export async function canCreate(user: IMarketingCloudUser): Promise<boolean> {
  return checkPermissionAcrossResources(user, ACTION_NAME.CREATE);
}

export async function canEdit(user: IMarketingCloudUser): Promise<boolean> {
  return checkPermissionAcrossResources(user, ACTION_NAME.EDIT);
}

export async function canRead(user: IMarketingCloudUser): Promise<boolean> {
  return checkPermissionAcrossResources(user, ACTION_NAME.READ);
}

export async function createActionValidator(
  user: IMarketingCloudUser,
): Promise<ActionValidationMiddleware> {
  const enforcer = await getCachedEnforcer(user);
  return new ActionValidationMiddleware(enforcer);
}

export async function getCachedEnforcer(user: IMarketingCloudUser): Promise<SportradarEnforcer> {
  if (cachedEnforcer) {
    return cachedEnforcer;
  }
  cachedEnforcer = await new SportradarEnforcerFactory().createFromMarketingCloudUser(user);
  return cachedEnforcer;
}
